import PropTypes from 'prop-types'

export class AddressActionCreators {};
AddressActionCreators.propTypes = PropTypes.shape({
  add: PropTypes.func.isRequired,
  select: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  update: PropTypes.func.isRequired
});


// WEBPACK FOOTER //
// ./src/Components/checkout/models/AddressActionCreators.js